import { IJWT } from '@/lib/interfaces';
import { ERole } from '@/lib/enums';

export const ruMonth = [
  'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
  'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь',
];

export function isTouch(): boolean {
  if ('ontouchstart' in window || navigator.msMaxTouchPoints) {
    return true;
  } else {
    return false;
  }
}

export function setDevJWT(roles: ERole[] = [ERole.project_employee, ERole.employee]) {
  const fakeJWT: IJWT = {
    _id: '0',
    start_work_date: new Date().toISOString(),
    roles,
  };
  document.cookie = `JWT=.${ btoa(unescape(encodeURIComponent(JSON.stringify(fakeJWT)))) }.`;
}

export function getCookie(key: string): string {
  const allCookies = document.cookie.split(';');
  for (const cookie of allCookies) {
    const kvPair = cookie.split('=');
    if (kvPair[0].trim() === key) {
      return decodeURIComponent(kvPair[1]);
    }
  }
  return '';
}

// уcтанавливает cookie
export function setCookie(name: string, value: any) {
  // value = encodeURIComponent(value);
  document.cookie = name + '=' + value + ';path=/';
}

export function parseJWT(): IJWT | null {
  const jwt = getCookie('JWT');
  if (jwt) {
    const base64 = jwt.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    try {
      const data = JSON.parse(decodeURIComponent(escape(atob(base64))));
      return data;
    } catch (e) {
      return null;
    }
  } else if (process.env.NODE_ENV === 'single') {
    setDevJWT();
    parseJWT();
  }
  return null;
}

export function arrayToHash<T extends { _id: string | number }>(array: T[]): {[key: string]: T} {
  return array.reduce<{[key: string]: T}>((res, obj) => {
    res[obj._id] = obj;
    return res;
  }, {});
}

/**
 * Метод аналог pluck + unique
 * @param array массив откуда берем значения
 * @param field имя ключа, который выбираем
 * @param extraValues дополнительные значения, которые должны быть в списке
 */
export function getUniqueFields<T, K extends keyof T>(
  array: T[], field: K, extraValues?: Array<T[K]>,
): Array<Required<T>[K]> {
  return Array.from(
    array.reduce( (result: Set<Required<T>[K]>, obj): typeof result => {
      if (obj[field]) {
        result.add(obj[field]);
      }
      return result;
    }, new Set(extraValues) ),
  );
}

/**
 * @param month number, 0 based
 * @param year, not zero based, required to account for leap years
 * @return List numbers for each day of the month
 */
export function getDaysInMonth(month: number, year: number): number[] {
  // Since no month has fewer than 28 days
  const date = new Date(year, month, 1);
  const days: number[] = [];
  while (date.getMonth() === month) {
    const curDay = date.getDate();
    days.push(curDay);
    date.setDate(curDay + 1);
  }
  return days;
}
